import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

// Fetch all published quizzes
function* fetchQuizzes() {
  try {
    const result = yield call(AxiosCall, `/quiz/list_quizzes/`);
    yield put(actions.fetchQuizzesSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchQuizzesFailure(e));
  }
}

// Fetch single quiz details (with questions)
function* fetchQuiz(action) {
  try {
    const { quizId } = action.payload;
    const result = yield call(AxiosCall, `/quiz/${quizId}/quiz_detail/`);
    yield put(actions.fetchQuizSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchQuizFailure(e));
  }
}

// Fetch questions for a quiz (uses quiz_detail endpoint)
function* fetchQuizQuestions(action) {
  try {
    const { quizId } = action.payload;
    const result = yield call(AxiosCall, `/quiz/${quizId}/quiz_detail/`);
    yield put(actions.fetchQuizQuestionsSuccess(result.data.questions || []));
  } catch (e) {
    yield put(actions.fetchQuizQuestionsFailure(e));
  }
}

// Start a new quiz attempt
function* startQuizAttempt(action) {
  try {
    const { quizId, numQuestions } = action.payload;
    const result = yield call(
      AxiosPost,
      `/quiz/${quizId}/start_attempt/`,
      { num_questions: numQuestions }
    );
    yield put(actions.startQuizAttemptSuccess(result.data));
  } catch (e) {
    yield put(actions.startQuizAttemptFailure(e));
  }
}

// Submit an answer to a question
function* submitAnswer(action) {
  try {
    const { attemptId, questionId, optionId } = action.payload;
    const result = yield call(
      AxiosPost,
      `/quiz/submit_response/`,
      {
        attempt_id: attemptId,
        question_id: questionId,
        selected_option_id: optionId
      }
    );
    yield put(actions.submitAnswerSuccess(result.data));
  } catch (e) {
    yield put(actions.submitAnswerFailure(e));
  }
}

// Complete quiz attempt
// Results are calculated from responses already accumulated in local state.
// No API call needed — the responses were collected via submitAnswerSuccess.
function* completeQuizAttempt() {
  try {
    yield put(actions.completeQuizAttemptSuccess({}));
  } catch (e) {
    yield put(actions.completeQuizAttemptFailure(e));
  }
}

// Fetch user's quiz attempts history
function* fetchUserAttempts() {
  try {
    const result = yield call(AxiosCall, `/quiz/my_attempts/`);
    yield put(actions.fetchUserAttemptsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchUserAttemptsFailure(e));
  }
}

// Fetch detailed results of a specific attempt
function* fetchAttemptDetails(action) {
  try {
    const { attemptId } = action.payload;
    // Fetch all attempts and find the specific one
    const result = yield call(AxiosCall, `/quiz/my_attempts/`);
    const attempt = result.data.find(a => a.id === attemptId);
    yield put(actions.fetchAttemptDetailsSuccess(attempt || null));
  } catch (e) {
    yield put(actions.fetchAttemptDetailsFailure(e));
  }
}

// Fetch question categories
function* fetchCategories() {
  try {
    // Note: Backend doesn't have a categories endpoint exposed yet
    // This might need to be added to the backend
    const result = yield call(AxiosCall, `/quiz/list_quizzes/`);
    yield put(actions.fetchCategoriesSuccess([]));
  } catch (e) {
    yield put(actions.fetchCategoriesFailure(e));
  }
}

// Root saga
export default function* quizSaga() {
  yield all([
    takeLatest(actions.FETCH_QUIZZES.REQUEST, fetchQuizzes),
    takeLatest(actions.FETCH_QUIZ.REQUEST, fetchQuiz),
    takeLatest(actions.FETCH_QUIZ_QUESTIONS.REQUEST, fetchQuizQuestions),
    takeLatest(actions.START_QUIZ_ATTEMPT.REQUEST, startQuizAttempt),
    takeLatest(actions.SUBMIT_ANSWER.REQUEST, submitAnswer),
    takeLatest(actions.COMPLETE_QUIZ_ATTEMPT.REQUEST, completeQuizAttempt),
    takeLatest(actions.FETCH_USER_ATTEMPTS.REQUEST, fetchUserAttempts),
    takeLatest(actions.FETCH_ATTEMPT_DETAILS.REQUEST, fetchAttemptDetails),
    takeLatest(actions.FETCH_CATEGORIES.REQUEST, fetchCategories),
  ]);
}
